import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 📁 How to Create a Collection

Follow these steps to create a new collection in HawkClient.

---

## ➕ Step 1: Add Collection

Click on the **Add Collection (+)** icon under the **Collections** tab at the top of the left sidebar.

![Add Collection](/getting-started/createCollection.png)

---

## ✏️ Step 2: Configure Collection Details

A dialog box will appear in the center of the screen asking for:

- **Collection Name**
- **Directory** (optional)

### 📂 Directory Field Notes
- The **Directory** field is optional
- If left empty, the collection is stored under the **workspace folder** by default
- **Recommended:** Keep this field empty so all collections reside under a single GitHub repository  
  *(workspace location / repo)*

This setup makes collaboration and version control easier.

---

## ✅ Done!

Your collection is now ready.  
You can start adding folders, requests, variables, and scripts.
`;

const CreateCollection = () => {
    return (
        <MarkDownRenderer
            title="Create Collection"
            markDownText={markdownContent}
        />
    );
};

export default CreateCollection;
